import { useCallback } from "react";
import { ProfileApiFactory } from "@/apis/profile";
import { SubscriptionApiFactory } from "@/apis/subscription";

export function useInitializeSession() {
  const initializeSession = useCallback(() => {
    return Promise.allSettled([ProfileApiFactory.Apis.FetchCustomerProfile(), ProfileApiFactory.Apis.FetchCompanyProfile(), SubscriptionApiFactory.Apis.FetchUserSubscription()]).then((results) => ({
      profile: {
        customer: results[0].status === "fulfilled" ? results[0].value.data : null,
        company: results[1].status === "fulfilled" ? results[1].value.data : null,
      },
      subscription: results[2].status === "fulfilled" ? results[2].value.data : null,
    }));
  }, []);

  return initializeSession;
}
